module.exports = __webpack_public_path__ + "static/media/tr.c85669e6.webp";